import React from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";

import { Route, Switch, useLocation, Redirect } from "react-router-dom";
import { SCHOOL_INFO } from "utils/constants";

// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import Group from "components/Group/Group";
import routes from "routes.js";
import ProjectProgress from "components/Project/projectprogress";
import NotAuth from "components/NotAuth/NotAuth";
import IndProjectProgress from "components/Project/indprojectprog";
import GroupProjectProgress from "components/Project/groupprojectprog";
import StudentDashboard from '../views/capstone/Dashboard';
import CourseGrading from "components/Course/grading";
import ProgressReport from "views/ProgressReport";
//import IvyAIChatBot from "components/bot/ai"
var ps;

function AdminLayout() {
  const location = useLocation();
  const mainPanel = React.useRef();
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current);
      document.body.classList.toggle("perfect-scrollbar-on");
    }
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
        document.body.classList.toggle("perfect-scrollbar-on");
      }
    };
  });
  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainPanel.current.scrollTop = 0;
  }, [location]);


  const isModuleEnabled = (path) => {
    if (path === "/home" || path === "/") return true;
    const key = path.replace(/^\//, "");
    const moduleKey = key === "StudentDashboard" ? "capstone" : key;
    return SCHOOL_INFO?.modules?.[moduleKey] !== false;
  };

  return (
    
    <div className="wrapper">
      <Sidebar routes={routes} />
      <div className="main-panel" ref={mainPanel}>
        <DemoNavbar />
        <Switch>
          {routes.map((prop, key) => {
            if (!isModuleEnabled(prop.path)) {
              return (
                <Route
                  exact path={prop.path}
                  key={key}
                  render={() => <Redirect to="/no-auth" />}
                />
              );
            }
            return (
              <Route
                exact path={prop.path}
                component={prop.component}
                key={key}
              />
            );
          })}
          <Route 
            exact 
            path="/groups/:id" 
            render={(routeProps) => isModuleEnabled("/groups") ? <Group {...routeProps} /> : <Redirect to="/no-auth" />}
          />
          <Route 
            exact 
            path="/projects/:id" 
            render={(routeProps) => isModuleEnabled("/projects") ? <IndProjectProgress {...routeProps} /> : <Redirect to="/no-auth" />}
          />
          <Route 
            exact 
            path="/groupprojects/:groupid/:id"
            render={(routeProps) => isModuleEnabled("/groupprojects") ? <GroupProjectProgress {...routeProps} /> : <Redirect to="/no-auth" />}
          />
          <Route 
            exact 
            path="/groups/:id/p/:proid" 
            render={(routeProps) => isModuleEnabled("/groups") ? <ProjectProgress {...routeProps} /> : <Redirect to="/no-auth" />}
          />
          <Route 
            exact 
            path="/course/:id" 
            render={(routeProps) => isModuleEnabled("/course") ? <CourseGrading {...routeProps} /> : <Redirect to="/no-auth" />}
          />
          <Route 
            exact 
            path="/progress-report" 
            render={(routeProps) => isModuleEnabled("/progress-report") ? <ProgressReport {...routeProps} /> : <Redirect to="/no-auth" />}
          />
          <Route 
            path="/StudentDashboard" 
            render={(routeProps) => isModuleEnabled("/StudentDashboard") ? <StudentDashboard {...routeProps} /> : <Redirect to="/no-auth" />}
          />

          <Route exact path="/no-auth" component={NotAuth}/>
        </Switch>
{/*          <IvyAIChatBot/>
 */}      </div>
     
    </div>
  );
}

export default AdminLayout;
